import React, { useCallback } from 'react';
import Seo from '../components/Seo';

const StaticDoc = ({ type }) => {
  const isPrivacy = type === 'privacy';
  const src = isPrivacy ? '/Privacy.html' : '/Terms.html';
  const onLoad = useCallback((e) => {
    try {
      const iframe = e.currentTarget;
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return;
      const style = doc.createElement('style');
      style.textContent = `
        .header, footer.footer { display: none !important; }
        body { background: transparent !important; }
        main { 
          max-width: 1000px !important; 
          margin: 0 auto !important; 
          box-shadow: none !important; 
          border: none !important;
        }
      `;
      doc.head && doc.head.appendChild(style);
    } catch (_) {}
  }, []);
  return (
    <>
      <Seo
        title={isPrivacy ? 'Privacy Policy' : 'Terms & Conditions'}
        description={
          isPrivacy
            ? 'Read KeepMyAsset privacy policy: how we protect your family asset records, nominee data, encryption practices, and your rights.'
            : 'Read KeepMyAsset terms and conditions for using our nominee alert and family asset protection platform.'
        }
        path={isPrivacy ? '/privacy' : '/terms'}
      />
    <div style={{ width: '100%', margin: '0 auto', padding: '12px 0 24px' }}>
      <iframe
        title={type === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'}
        src={src}
        onLoad={onLoad}
        style={{ width: '100%', minHeight: '80vh', border: 'none' }}
      />
    </div>
    </>
  );
};

export default StaticDoc;


